/*
* KEINE `messages` MEHR HIER (30.08.2026).
*
* Bis @nuxtjs/i18n 8 wurden die Texte an dieser Stelle eingehaengt. Seit
* Fassung 9 laedt das Modul sie selbst — ueber `langDir` und `locales[].file`
* in `nuxt.config.ts`. Blieben sie zusaetzlich hier stehen, wuerde dieselbe
* Datei zweimal verarbeitet.
*
* Was hier BLEIBT, sind die Zahlen- und Datumsformate: Sie gehoeren zur
* vue-i18n-Konfiguration, nicht zu den Texten.
*/
export default (nuxt) => ({
	legacy: false,
	warnHtmlInMessage: "off",
	locale: "de",
	numberFormats: { "de": {
		currency: {
			style: "currency",
			currency: "EUR",
			currencyDisplay: "symbol",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		},
		currencyShort: {
			style: "currency",
			currency: "EUR",
			currencyDisplay: "symbol",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		},
		fractionlessPercent: {
			style: "percent",
			maximumFractionDigits: 0
		},
		twoFractionDigitsPercent: {
			style: "percent",
			maximumFractionDigits: 2
		},
		chart: {
			style: "currency",
			currency: "EUR",
			currencyDisplay: "symbol",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}
	} },
	datetimeFormats: { "de": {
		short: {
			year: "numeric",
			month: "short",
			day: "2-digit"
		},
		medium: {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "numeric",
			minute: "numeric"
		},
		long: {
			year: "numeric",
			month: "long",
			day: "numeric",
			weekday: "long",
			hour: "numeric",
			minute: "numeric"
		},
		chart: {
			year: "numeric",
			month: "2-digit"
		},
		iso: {
			year: "numeric",
			month: "2-digit",
			day: "2-digit"
		}
	} }
});
